export default {
    state:{
        videoInfo:{},
        recordStatus:{},
        smtpInfo:{},
    },
    mutations:{
        setVideoInfo(state,val){
            state.videoInfo = {...val};
        },
        setRecordStatus(state,val){
            state.recordStatus = {...val};
        },
        setSmtpInfo(state,val){
            state.smtpInfo = {...val};
        }
    },
    actions:{

    },
    getters:{

    }
}


// WEBPACK FOOTER //
// ./src/cmtapp/store/play.js